export default __webpack_public_path__ + "ui/assets/img/support-avatar-32.svg";